import React, { useEffect, useState, Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from 'components/Button';
import qs from 'qs';
import Spin from 'components/Spin';
import { getUpsells } from 'services/pages.svc';
import cart from '../cart';
import { Card } from '../styled';

export default ({ location, history }) => {
  const [loading, setLoading] = useState(true);
  const [upsells, setUpsells] = useState([]);
  const { i } = qs.parse(location.search.substr(1));

  useEffect(() => {
    if (!upsells.length) {
      getUpsells().then((r) => {
        setUpsells(r);
        setLoading(false);
      });
    }
  }, [i]);

  const onAccept = () => {
    const offers = cart.get('offers') || [];
    offers.push(data);
    cart.set('offers', offers);
    history.push(nextLink);
    window.scrollTo(0, 0);
  };

  if (i === undefined) {
    history.push('/404');
  }

  const nextIdx = Number(i) + 1;
  const data = upsells[i] || {};
  const nextData = upsells[nextIdx];
  let nextLink = '/offer/confirm';
  if (nextData && nextData.enabled === 1 && nextData.key !== 'break') {
    nextLink = `/offer/?i=${nextIdx}`;
  }
  return (
    <Fragment>
      <Box className="logo" textAlign="center" pb={4}>
        <a href="/">
          <img src={`/assets/svg/tic-logo-full.svg`} alt="logo" />
        </a>
      </Box>
      <Helmet title={data.offer_h1 || 'Offers'} />
      {loading ? (
        <Spin spinning />
      ) : (
        <Card sx={{ maxWidth: 760, mx: 'auto', px: 3, py: 4 }}>
          <Typography align="center" variant="h2">
            {data.offer_h1}
          </Typography>
          <Box mt={4}>
            <Box
              mb={4}
              dangerouslySetInnerHTML={{ __html: data.offer_video }}
            />
            <Typography
              paragraph
              lineHeight="32px"
              align="center"
              variant="h3"
              dangerouslySetInnerHTML={{ __html: data.offer_h2 }}
            />
            <Box my={4} textAlign="center">
              <Button size="large" onClick={onAccept}>
                Yes, I want this
              </Button>
            </Box>
            <div dangerouslySetInnerHTML={{ __html: data.offer_details }} />
            <Box textAlign="center" my={4}>
              <Button
                onClick={onAccept}
                type="submit"
                size="large"
                sx={{ mr: 2 }}
              >
                Yes, I want this
              </Button>
              <Box display={{ xs: 'block', md: 'inline' }}>
                <MuiLink component={Link} to={`${nextLink}`}>
                  No thanks, I'll pass
                </MuiLink>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{ textAlign: 'center' }}
            dangerouslySetInnerHTML={{ __html: data.offer_disclaimer }}
          />
        </Card>
      )}
    </Fragment>
  );
};
